import axios from 'axios'
import Vue from 'vue'
import {
  baseUrl
} from '../../config/config'
import qs from 'qs'
// import store from '@/store'
/**
 * @description 请求拦截器
 */

// 全局设置 axios 发送请求带上cookie
axios.defaults.withCredentials = true
axios.interceptors.request.use(
  config => {
    // let token = store.getters.getIsLogined()
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`
    // }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(function (response) {

  return response.data
}, function (error) {
  return Promise.reject(error)
})


export const GET = (url, params, options = {}) => {
  let conf = Object.assign({
      baseURL: baseUrl
    },
    options, {
      params,
      paramsSerializer: function (params) {
        return qs.stringify(params, {
          arrayFormat: 'repeat'
        })
      },
    })
  return axios.get(url, conf).then(data => {
    // return response
    return data
  })
}

export const POST = (url, params, options) => {
  return axios.post(url, params, Object.assign({
    baseURL: baseUrl
  }, options)).then(data => data)
}
